<template>
<div class="page">
  <div class="tags">
    <a class="tag size-large" v-for="(tag, n) in tags" :key="n" target="_blank" :href="`https://www.instagram.com/explore/tags/${tag}/`">
      #{{tag}}
    </a>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default Vue.component('RouteTags', {
  computed: {
    tags() {
      return this.$store.getters['site/instagramTags']
    }
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.page {
  min-height: 100vh;
  background: $color-white;
  padding-top: 9.6rem;
}

.tags {
 padding: $gutter;
}
.tag {
  text-transform: uppercase;
  display: inline-block;
  background: $color-red;
  margin: 0 0.3em 0.3em 0;
  padding: 0 0.2em;
  @media (max-width: $break-small) {
    font-size: $size-medium;
  }
  &:hover {
    color: $color-black;
  }
}
</style>


// WEBPACK FOOTER //
// src/routes/route-tags.vue